import type { TemplateLanguage } from './types';

const LANGUAGES: readonly string[] = ['uz', 'ru', 'en'];

/** Template language for a UI language ('ru-RU' → 'ru'); Uzbek when unknown. */
export function templateLanguageFor(uiLanguage: string | undefined): TemplateLanguage {
  const short = uiLanguage?.slice(0, 2) ?? '';
  return (LANGUAGES.includes(short) ? short : 'uz') as TemplateLanguage;
}
